import React from "react";
import { Routes, Route, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import LaborTable from "components/laborTable";
import ExceptionPricing from "components/laborTable/exceptionPricing";
import SiteRepo from "components/siteRepo";
import BulkUpdateSite from "components/siteRepo/viewSite/BulkUpdateSite";
import PriceQuote from "components/priceQuote";
import ProgramBuilder from "components/programBuilder";
import CreateProgram from "components/programBuilder/createProgram";
import ProgramHomePage from "components/programBuilder/programHomePage";
import Cookie from "components/cookie";
import QuoteTabs from "components/priceQuote/quoteTabs";
import QuoteCreation from "components/priceQuote/quoteCreation";
import CreateSite from "components/siteRepo/createSite";
import ViewSite from "components/siteRepo/viewSite";
import EditSite from "components/siteRepo/editSite";
import CreateQuote from "components/siteRepo/createQuote";
import BulkUpdateProducts from "components/siteRepo/bulkUpdateProducts";
import ChangeLog from "components/siteRepo/changeLog";
import NotFound from "components/404";
import FloorPlanDetails from "components/priceQuote/floorPlanDetails";
import UpdatePrc from "components/priceQuote/updatePrc";
import BulkUpdateQuote from "components/priceQuote/bulkUpdateQuote";
import UpdateLaborPricing from "components/priceQuote/updateLaborPricing";
import Container from "react-bootstrap/Container";
import QuoteHeader from "../components/priceQuote/QuoteHeader";

const RouterComponent = () => {
  const { fcRole, hasPbAccess, hasUpdateAccess } = useSelector((state) => state.loggedInUser);
  const isDev = location.hostname.indexOf("dev") >= 0 || location.hostname.indexOf("localhost") >= 0;
  const fcHubAccess = fcRole && fcRole !== "";

  return (
    <Routes>
      {fcHubAccess && (
        <>
          <Route path="laborTable" element={<Container fluid="xl" className="flex-grow-1 p-3" children={<Outlet />} />}>
            <Route index element={<LaborTable />} />
            <Route path="expectionPricing" element={<ExceptionPricing />} />
          </Route>

          <Route path="siteRepo" element={<Container fluid="xl" className="flex-grow-1 p-3" children={<Outlet />} />}>
            <Route index element={<SiteRepo />} />
            <Route path="createSite" element={<CreateSite />} />
            <Route path="site/:siteId" element={<ViewSite />} />
            <Route path="bulkUpdateSite/:siteId" element={<BulkUpdateSite />} />
            <Route path="editSite/:siteId" element={<EditSite />} />
            <Route path="createQuote/:siteId" element={<CreateQuote />} />
            <Route path="updateProducts" element={<BulkUpdateProducts />} />
            <Route path="changeLog/:siteId" element={<ChangeLog />} />
          </Route>

          <Route path="priceQuote" element={<Container fluid="xl" className="p-3" children={<Outlet />} />}>
            <Route index element={<PriceQuote />} />
            <Route path="createQuote" element={<QuoteCreation />} />
            <Route
              path=":quoteId"
              element={
                <>
                  <QuoteHeader />
                  <Outlet />
                </>
              }
            >
              <Route index element={<QuoteTabs />} />
              <Route path="updatePrc" element={<UpdatePrc />} />
              <Route path="updateLaborPricing" element={<UpdateLaborPricing />} />
              <Route path=":floorId" element={<FloorPlanDetails />} />
              <Route path="bulkUpdateQuote" element={<BulkUpdateQuote />} />
              {hasUpdateAccess && <Route path="updateLaborPricing" element={<UpdateLaborPricing />} />}
            </Route>
          </Route>

          {hasPbAccess && (
            <Route
              path="programBuilder"
              element={<Container fluid="xl" className="flex-grow-1 p-3" children={<Outlet />} />}
            >
              <Route index element={<ProgramBuilder />} />
              <Route path="createProgram" element={<CreateProgram />} />
              <Route path="programDetails/:programId" element={<ProgramHomePage />} />
            </Route>
          )}
        </>
      )}
      {isDev && (
        <Route
          path="/cookie"
          element={
            <Container fluid="xl" className="flex-grow-1 p-3">
              <Cookie />
            </Container>
          }
        />
      )}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};
export default RouterComponent;
